import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { useDispatch } from 'react-redux'
import { viewImage } from '../../CommonUtils/viewImage'
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64'
import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables'
import { FaEye } from 'react-icons/fa'
import { failureAlert } from '../../CommonUtils/SweetAlerts'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'

function AfflRenew() {
    const acYear = sessionStorage.getItem('ac_year')
    const hasFetchedData = useRef(false)
    const [pdf, setPdf] = useState('')
    const dispatch = useDispatch()

    const validationSchema = () => {
        const shouldValidate = Array.isArray(getrenew) && getrenew.length > 0;
        return Yup.object({
            data: Yup.array().of(
                Yup.object().shape({
                    deficiencyStatus: shouldValidate
                        ? Yup.string().required(ERROR_MSG).oneOf(["true", "false"], "Please select Yes or No")
                        : Yup.string().nullable(),

                    deficiencyRemarks: Yup.string().nullable().when("deficiencyStatus", {
                        is: "true",
                        then: shouldValidate ? Yup.string().required(ERROR_MSG) : Yup.string().nullable(),
                        otherwise: Yup.string().nullable(),
                    }),

                    deficiencyPdf: shouldValidate
                        ? Yup.string().nullable().required(ERROR_MSG)
                        : Yup.string().nullable(),
                })
            ),
        });
    };

    const AfflRenewformik = useFormik({
        initialValues: {
            data: [{
                deficiencyStatus: "",
                deficiencyRemarks: "",
                deficiencyPdf: "",
                deficiencyList: '',
                slno: ''
            }],
            latEopOrderPdf: ""
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            let dd = val?.data?.map(item => ({ ...item, latEopOrderPdf: val.latEopOrderPdf }))
            if ((val?.latEopOrderPdf === "No data found" && (pdf === '' || pdf === undefined || pdf === 'No data found'))) {
                Swal.fire({
                    title: 'Please select the latest EOP PDF order.',
                    icon: 'warning',
                    confirmButtonText: 'Okay',
                    backdrop: false,
                });
                return;
            }


            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `AfflRenew`
                    CommonAxiosPost(url, dd).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {
                                if (res?.isConfirmed) {
                                    window.location.reload()
                                }
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    })

    const [getrenew, setrenew] = useState([]);
    async function GetLatPdfData() {
        try {
            const url = `${config.url.API_URL}getLatpdf`;
            const res = await CommonAxiosGet(url, dispatch);
            setPdf(res?.data?.getLatpdf);
            AfflRenewformik?.setFieldValue("latEopOrderPdf", res?.data?.getLatpdf)
        } catch (error) {
            console.error("Error fetching PDF data:", error);
            setPdf('');
        }

        try {
            const urll = `${config.url.API_URL}getAfflRenew`;
            const res2 = await CommonAxiosGet(urll, dispatch);
            if (res2?.data?.scode === '01') {
                const data = res2?.data?.afflRenew;
                setrenew(data);
                const listData = data && data?.length > 0
                    ? data.map((ld) => ({
                        deficiencyList: ld?.description || '',
                        deficiencyStatus: ld?.coll_deficiency_status == true ? 'true' : ld?.coll_deficiency_status == false ? "false" : '',
                        deficiencyRemarks: ld?.coll_deficiency_remarks || '',
                        deficiencyPdf: ld?.coll_deficiency_pdf || '',
                        slno: ld?.sl_no || '',

                    }))
                    : [{ deficiencyStatus: "", deficiencyRemarks: "", deficiencyPdf: "", deficiencyList: '' }];

                AfflRenewformik.setFieldValue('data', listData);
            } else {
                AfflRenewformik.setFieldValue('data', [{ deficiencyStatus: "", deficiencyRemarks: "", deficiencyPdf: "", deficiencyList: '' }]);
            }
        } catch (error) {
            console.error("Error fetching affiliation renewal data:", error);
            AfflRenewformik.setFieldValue('data', [{ deficiencyStatus: "", deficiencyRemarks: "", deficiencyPdf: "", deficiencyList: '' }]);
        }
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetLatPdfData()
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>                <CommonFormHeading heading={`Affiliation ${acYear}`} />

            <bie.Container className="outer-page-content-container shadow-none px-2 m-0 mw-100 pb-3"  >
                <bie.Row className="px-4 pt-3 mb-4">
                    <FormikProvider value={AfflRenewformik}>
                        <Form onChange={AfflRenewformik.handleChange} onSubmit={AfflRenewformik.handleSubmit} className="affl-form">
                            <bie.Row className="px-3 pt-3 m-0 pb-3">
                                <bie.Alert variant='danger'>
                                    <b style={{ color: 'red' }}>Note *</b>:<br />
                                    1) In the Case if your Competent Authority is APSCHE and if your College Accommodation is Own, Please upload any Latest Proceedings issued by APSCHE for this College<br />

                                    2) In case if multiple documents are available please merge all the documents in a Single PDF and Upload
                                </bie.Alert>
                            </bie.Row>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Approval of Competent Authority (AICTE/APSCHE/ BCI/PCI) - {acYear}</h1>
                            </div>
                            <div className='pt-4'>
                                <bie.Row >
                                    <bie.Col xs={12} sm={12} md={12} lg={10} xl={6} xxl={6} classname=''>
                                        <label className=''><b style={{ color: 'red' }}>* </b>Latest EOP/EOA issued by Competent Authority (AICTE/APSCHE/BCI/NCTE): </label>
                                        <input type="file" name="latEopOrderPdf" className="form-control mb-3" accept="application/pdf"
                                            onChange={(e) => {
                                                let filename = `latEopOrderPdf`;
                                                let path = "/Uploads/Affiliation2023/";
                                                ImagePdfBucket(e, AfflRenewformik, path, `latEopOrderPdf`, filename, "pdf");
                                            }} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='pt-4 mb-3'>

                                        {(pdf !== 'No data found') && (<>
                                            <button type="button" onClick={() => viewImage(pdf)} className="btn btn-primary "><FaEye size={25} /></button>
                                        </>

                                        )}
                                    </bie.Col>

                                </bie.Row>
                            </div>

                            {getrenew.length > 0 && (<>
                                <div className="inner-herbpage-service-title-sub"  >
                                    <h1 className="">Compliance of the Deficiencies Reported in Affiliation Order {AC_YEAR_OLD}</h1>
                                </div>
                                <div className='table-responsive'>
                                    <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>List of Deficiencies</th>
                                                <th>Complied as on date</th>
                                                <th>How it is complied</th>
                                                <th style={{ width: '40%' }}>Upload (Any evidentiary document to support /justify Claim of Compliance)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {AfflRenewformik?.values?.data.map((dd, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td className='text-left'>{dd?.deficiencyList}</td>
                                                    <td>
                                                        <div style={{ position: 'relative' }}>
                                                            <Field as='select' name={`data[${i}].deficiencyStatus`} className='form-control'
                                                                onChange={() => AfflRenewformik.setFieldValue(`data[${i}].deficiencyRemarks`, '')}>
                                                                <option value=''>--SELECT--</option>
                                                                <option value='true'>Yes</option>
                                                                <option value='false'>No</option>

                                                            </Field>

                                                        </div>
                                                        <ErrorMessage name={`data[${i}].deficiencyStatus`} className='text-error' component='div' />
                                                    </td>
                                                    <td>
                                                        {AfflRenewformik?.values?.data[i]?.deficiencyStatus === 'true' && (
                                                            <>
                                                                <Field as='textarea' name={`data[${i}].deficiencyRemarks`} className='form-control' />
                                                                <ErrorMessage name={`data[${i}].deficiencyRemarks`} className='text-error' component='div' />
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <bie.Row className='align-items-center mx-0'>
                                                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} className='pt-4 mb-3'>
                                                                <input type='file' name={`data[${i}].deficiencyPdf`} className='form-control' accept="application/pdf"
                                                                    onChange={(e) => {
                                                                        let filename = `deficiencyPdf`;
                                                                        let path = "/Uploads/Affiliation2023/";
                                                                        ImagePdfBucket(e, AfflRenewformik, path, `data[${i}].deficiencyPdf`, filename, "pdf");

                                                                    }} />
                                                                <ErrorMessage name={`data[${i}].deficiencyPdf`} className='text-error' component='div' />
                                                            </bie.Col>
                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='pt-4 mb-3'>
                                                                {
                                                                    AfflRenewformik?.values?.data?.[i]?.deficiencyPdf && (
                                                                        <button type='button' onClick={() => viewImage(AfflRenewformik?.values?.data[i]?.deficiencyPdf)} className="btn btn-primary"><FaEye size={23} />
                                                                        </button>
                                                                    )
                                                                }

                                                            </bie.Col>

                                                        </bie.Row>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>
                            </>)}
                            <button type='submit' className='btn btn-success btn-sm btn float-end mb-2'>Submit</button>
                        </Form>
                    </FormikProvider>
                </bie.Row>
            </bie.Container>

        </>
    )
}

export default AfflRenew
